import { useEffect, useState } from "react";
import 'react-accessible-accordion/dist/fancy-example.css';
import { FaSpinner } from "react-icons/fa";
import { connect, useDispatch } from "react-redux";
import { Col, Input, Row } from "reactstrap";
import Select from "react-select";
import swal from "sweetalert";
import { logout } from "../../../../store/actions/AuthActions";
import { api } from "../../../../utils/api";
import { translate } from "../../../../utils/translate";
import { languageList } from "../../../../utils/config";
import { Link, useHistory } from "react-router-dom";
import customSelectStyles from "../../SelectStyle";
import { formatLang } from "../../../../utils/function";

const statusList = [
    { value: 'Active', label: 'Active' },
    { value: 'Disabled', label: 'Inactive' },
    { value: 'Deleted', label: 'Deleted' },
]

const AddAnnouncement = (props) => {
    const dispatch = useDispatch();
    const history = useHistory();
    const descriptionFormat = {
        title: '',
        language: '',
        description: '',
    }
    const errorFormat = { error_title: '', error_description: '', language: '' };
    const [formData, setFormData] = useState({
        status: 'Active',
        type: 'announcement',
        description: [],
    });
    let errorObj = { status: '', type: '', description: "" };
    const [errors, setErrors] = useState(errorObj);
    const [loading, setLoading] = useState(false);
    const [tab, setTab] = useState('');
    const [errorDescription, setErrorDescription] = useState([]);

    useEffect(() => {
        setTab(languageList.length > 0 ? languageList[0].code : '');
        let array = [];
        let errorArr = [];
        let newFormData = { ...formData };
        languageList.map((item) => {
            array.push({ ...descriptionFormat, language: item.code })
            errorArr.push({ ...errorFormat, language: item.code })
        })
        newFormData.description = array;
        setFormData(newFormData);
        setErrorDescription(errorArr);
    }, [])

    const handleAddFormChange = (event) => {
        event.preventDefault();
        const fieldName = event.target.getAttribute('name');
        let fieldValue = event.target.value;
        const newFormData = { ...formData };
        newFormData.description.map((item, i) => {
            if (item.language === tab) {
                item[fieldName] = fieldValue;
            }
        })
        setFormData(newFormData);
    }

    const submit = () => {
        let check = true;
        const errorMsg = { ...errorObj };
        let newFormData = { ...formData };
        let errorArr = [...errorDescription];
        let newArr = formData.description;
        if (formData.description.length === 0) {
            check = false;
            swal(translate(props.lang, "Error"), translate(props.lang, "Please fill in announcement for at least one language"), "error");
        } else {
            newArr.map(async (item) => {
                let index = errorArr.findIndex(obj => obj.language === item.language);
                if (!item.description) {
                    check = false;
                    errorArr[index].error_description = "This field is required.";
                } else {
                    errorArr[index].error_description = "";
                }
                if (!item.title) {
                    check = false;
                    errorArr[index].error_title = "This field is required.";
                } else {
                    errorArr[index].error_title = "";
                }
            })
        }
        setErrorDescription(errorArr);
        setErrors(errorMsg);
        if (check) {
            setLoading(true);
            fetch(api.add_announcement, {
                method: "POST",
                headers: new Headers({
                    "Content-Type": "application/json",
                    "Accept-Language": props.lang,
                    "Authorization": "Bearer " + props.auth.auth.access_token

                }),
                body: JSON.stringify(formData)
            })
                .then(response => response.json())
                .then(responseJson => {
                    setLoading(false);
                    if (responseJson.status === "success") {
                        resetForm();
                        swal(translate(props.lang, 'Success'), responseJson.message, "success");
                        history.push('/system/announcement');
                    } else {
                        if (responseJson.status === 'error' && responseJson.message.toLowerCase() === 'token expired') {
                            dispatch(logout(props.history, 'login'));
                        }
                        if (responseJson.data && typeof responseJson.data.error === 'object') {
                            let apiErrorMsg = { ...errorObj };
                            let popupMessage = [];
                            Object.keys(responseJson.data.error).map((key) => {
                                apiErrorMsg[key] = responseJson.data.error[key];
                                popupMessage.push(responseJson.data.error[key]);
                            })
                            setErrors(apiErrorMsg);
                            swal(translate(props.lang, "Error"), popupMessage.join('\n'), "error");
                        } else {
                            swal(translate(props.lang, "Error"), responseJson.message, "error");
                        }
                    }
                }).catch(error => {
                    console.error("error", error);
                });
        }
    }

    const changeTab = (val) => {
        setTab(val)
    }

    const resetForm = () => {
        setTab(languageList.length > 0 ? languageList[0].code : '');
        let array = [];
        let errorArr = [];
        languageList.map((item) => {
            array.push({ ...descriptionFormat, language: item.code })
            errorArr.push({ ...errorFormat, language: item.code })
        })
        setFormData({
            status: 'Active',
            type: 'announcement',
            description: array,
        })
        setErrorDescription(errorArr);
    }

    return (
        <>
            <div className='pb-5 wallet'>
                <Row className="mx-0 px-0 mt-3 mt-md-0">
                    <Col lg={12} md={12} sm={12} xs={12} className="px-0">
                        <div className="d-flex align-items-center w-100 mb-4">
                            <Link to="/system/announcement" className="cursor-pointer">
                                <div className="d-flex align-items-center">
                                    <img src={require('../../../../images/icon/backBtn.svg').default} className="img-fluid" alt="back" />
                                </div>
                            </Link>
                            <div className="ms-3">
                                <span className="infoTitle">{translate(props.lang, "New Announcement")}</span>
                            </div>
                        </div>
                        <div className="card-white py-4">

                            <div className="px-md-5 px-2 py-4">
                                <Row className="px-0 mx-0">
                                    <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                        <Row className="px-0 mx-0 tab-container mb-3">
                                            {languageList.map((item, i) => (
                                                <Col lg={3} md={3} sm={3} xs={3} key={i} className={`tab-item h-100 text-center px-4 py-3 buy ${tab === item.code ? 'active' : ""}`} onClick={() => changeTab(item.code)}>
                                                    <span className="font-weight-600 font-16 text-capitalize">{item.name}</span>
                                                </Col>
                                            ))}
                                        </Row>
                                    </Col>
                                    {formData.description.length > 0 ? (
                                        <>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                                <span className="font-16 font-weight-600 text-grey-2 ps-2">{translate(props.lang, "Title")}</span>
                                                <div className={`groupLabel-input ${errorDescription.length > 0 ? errorDescription.filter(item => item.language === tab)[0].error_title ? 'errorBorder' : '' : '' ? 'errorBorder' : ''}   mt-2 mb-1`}>
                                                    <div className="input-group">
                                                        <Input
                                                            type="text"
                                                            placeholder={translate(props.lang, "Enter title") + " (" + formatLang(languageList.filter(item => item.code === tab)[0].name) + ")"}
                                                            className="form-control input-transparent py-1 px-3"
                                                            onChange={e => handleAddFormChange(e)}
                                                            name="title"
                                                            value={formData.description.filter(item => item.language === tab).length > 0 ? formData.description.filter(item => item.language === tab)[0].title : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <span className="font-weight-400 font-14 errorTextRed ms-0">{errorDescription.length > 0 ? translate(props.lang, errorDescription.filter(item => item.language === tab)[0].error_title) : ''}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                                <span className="font-16 font-weight-600 text-grey-2 ps-2">{translate(props.lang, "Description")}</span>
                                                <div className={`groupLabel-textarea ${errorDescription.length > 0 ? errorDescription.filter(item => item.language === tab)[0].error_description ? 'errorBorder' : '' : '' ? 'errorBorder' : ''}   mt-2 mb-1`}>
                                                    <div className="input-group">
                                                        <Input
                                                            type="textarea"
                                                            placeholder={translate(props.lang, "Enter Description") + " (" + formatLang(languageList.filter(item => item.code === tab)[0].name) + ")"}
                                                            className="form-control input-transparent py-1 px-3"
                                                            onChange={e => handleAddFormChange(e)}
                                                            name="description"
                                                            value={formData.description.filter(item => item.language === tab).length > 0 ? formData.description.filter(item => item.language === tab)[0].description : ''}
                                                        />
                                                    </div>
                                                </div>
                                                <span className="font-weight-400 font-14 errorTextRed ms-0">{errorDescription.length > 0 ? translate(props.lang, errorDescription.filter(item => item.language === tab)[0].error_description) : ''}</span>
                                            </Col>
                                            <Col lg={12} md={12} sm={12} xs={12} className="mb-3">
                                                <span className="font-16 font-weight-600 text-grey-2 ps-2">{translate(props.lang, "Status")}</span>
                                                <div className={`input-group-select  ${errors.status ? 'errorBorder' : ''}  mt-2 mb-1`}>
                                                    <Select
                                                        options={
                                                            statusList.length > 0 ? statusList.map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })) : [{ value: '', label: translate(props.lang, "No options available") }]
                                                        }
                                                        placeholder={translate(props.lang, "Status")}
                                                        className="input-transparent w-100 text-capitalize"
                                                        styles={customSelectStyles}
                                                        isSearchable={false}
                                                        value={
                                                            statusList.filter(item => item.value == formData.status).length > 0 ?
                                                                (statusList.filter(item => item.value == formData.status).map((item, i) => ({ key: i, value: item.value, label: translate(props.lang, item.label) })))
                                                                : null
                                                        }
                                                        name="status"
                                                        onChange={(e) => setFormData(prevState => ({ ...prevState, status: e ? e.value : '' }))}
                                                    />
                                                </div>
                                                <span className="font-weight-400 font-14 errorTextRed ms-0">{translate(props.lang, errors.status)}</span>
                                            </Col>
                                        </>
                                    ) : null}

                                    <Col lg={12} md={12} sm={12} xs={12} className="mt-4">
                                        <button className="primary-btn px-4 py-2 text-center mx-auto w-100" onClick={() => submit()}>
                                            <span className={`btnText`}>{loading ? <FaSpinner className="fa-spin" /> : translate(props.lang, "Submit")}</span>
                                        </button>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
        </>
    )
}

const mapStateToProps = state => {
    const { auth, i18n } = state;
    return {
        lang: i18n.lang,
        auth: auth,
    }
}

export default connect(mapStateToProps)(AddAnnouncement);